import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_PETITIONS_IN_FOOTER_WELL = createFcmDetails('promoted_petitions_in_footer_well', {
	owner: 'supporters pack',
	context: 'search page',
	description: 'Indicates whether to display promoted petitions in the footer well on petition details or search page.',
	import: false,
});
